<template>
  <div class="toast-container top-0 end-0">
    <div
      id="toast-new-message"
      class="toast alert alert-dismissible"
      :class="[typeAlert]"
    >
      <div class="alert__icon">
        <Icon :name="toast.icon || 'ban'" />
      </div>
      <div class="alert__content">
        {{ toast.message }}
      </div>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="toast"
        aria-label="Fechar"
        @click="toggleToastGlobal({ isShow: false })"
      >
        <Icon name="xmark" />
      </button>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { mapActions, mapState } from 'pinia'
  import { useToastGlobal } from '@/store/Pinia/useToastGlobal.store'
  import Icon from '@/components/Atoms/Icon.vue'
  import { Toast } from 'bootstrap'

  export default defineComponent({
    name: 'ToastGlobalComponent',
    components: {
      Icon,
    },
    data: () => ({}),
    watch: {
      'toast.isShow': function w(curr) {
        if (curr) {
          this.showToast()
          setTimeout(() => {
            this.toggleToastGlobal({ isShow: false })
          }, 5000)
        }
      },
    },
    computed: {
      ...mapState(useToastGlobal, ['toast']),
      typeAlert() {
        return `alert-${this.toast.type || 'danger'}`
      },
    },
    methods: {
      ...mapActions(useToastGlobal, ['toggleToastGlobal']),
      showToast() {
        const toast = new Toast('#toast-new-message')
        toast.show()
      },
    },
  })
</script>

<style lang="stylus" scoped>

  .alert__icon, .btn-close
    display: flex
    align-items: center
    justify-content: center
</style>
